import type { QueriesPaginationResponse } from '@empathybroker/tsclient-stats/dist/models/queries-pagination/queries-pagination.response'
import type { QueriesResponse } from '@empathybroker/tsclient-stats/dist/models/queries/queries.response'
import type { ActionContext } from 'vuex'
import type { ActionClass, AnalyticsState, Pagination, QueriesSearchData } from '../../../models'
import type { ContextProvider } from '../../../providers'
// @ts-strict-ignore
import { StatsReportsIdsEnum } from '@empathybroker/tsclient-stats/dist/enums/stats-reports-ids.enum'
import { CONTAINER } from '../../../config'
import { TYPES } from '../../../config/inversify.types'
import { ANALYTICS_CONSTS } from '../analytics.consts'

export class LoadSearchDataAction implements ActionClass {
  static async execute(
    this: void,
    { dispatch, commit, state }: ActionContext<AnalyticsState, any>,
    pagination: Pagination,
  ): Promise<QueriesSearchData> {
    const {
      insights: { query },
    } = CONTAINER.get<ContextProvider>(TYPES.ContextProvider)()
    if (query) {
      let { queries: searchQueries, totals: searchTotals } = state.data.search[query] || {}

      const offset = (pagination.page - 1) * pagination.itemsPerPage
      if (!searchQueries || !searchTotals || searchQueries.length !== searchTotals.termsCount) {
        try {
          const searchQueriesResponse: QueriesResponse = await dispatch(
            ANALYTICS_CONSTS.actions.fetchStatsReport,
            {
              id: StatsReportsIdsEnum.QUERIES,
              params: {
                keywords: query,
                rows: pagination.itemsPerPage,
                offset,
              },
            },
          )
          searchQueries = searchQueriesResponse.data
          const searchTotalsResponse: QueriesPaginationResponse = await dispatch(
            ANALYTICS_CONSTS.actions.fetchStatsReport,
            {
              id: StatsReportsIdsEnum.QUERIES_PAGINATION,
              params: {
                keywords: query,
              },
            },
          )
          searchTotals = searchTotalsResponse.data
          commit(ANALYTICS_CONSTS.mutations.setSearchData, {
            queries: searchQueries,
            totals: searchTotals,
            query,
          })
        } catch (error) {
          throw error
        }
      }
      return {
        queries: searchQueries,
        totals: searchTotals,
      }
    }
  }
}
